import { Card, Col, Row, Steps, Typography } from "antd";
import { Link } from "react-router-dom";
import { PageHeader } from "../components/PageHeader";

const FLOWS = [
  {
    title: "Приёмка товара",
    steps: [
      { title: "Создать поступление", description: <Link to="/expected_receipts/new">Поступление → Ожидаемые поступления → Создать</Link> },
      { title: "Добавить строки", description: "На вкладке «Строки»: товар и плановое количество" },
      { title: "Подтвердить", description: "Кнопка «Подтвердить» в карточке документа" },
      { title: "Принять", description: "На ТСД в режиме «Приёмка по документу» или кнопкой «Принять» в карточке" },
      { title: "Разместить", description: "Кнопка «Спланировать»: система создаст задачи размещения" },
    ],
  },
  {
    title: "Отгрузка",
    steps: [
      { title: "Создать заказ", description: <Link to="/shipment_orders/new">Отгрузка → Заказы на отгрузку → Создать</Link> },
      { title: "Добавить строки и подтвердить", description: "Товар, количество, затем «Подтвердить»" },
      { title: "Спланировать отбор", description: "Кнопка «Спланировать» или объединить заказы в волну" },
      { title: "Отобрать на ТСД", description: "Исполнители берут задачи из очереди «Отбор»" },
      { title: "Отгрузить", description: "Кнопка «Отгрузить» в карточке заказа" },
    ],
  },
  {
    title: "Первый запуск склада",
    steps: [
      { title: "Зоны", description: <Link to="/zones">Топология → Зоны: приёмка, хранение, отгрузка</Link> },
      { title: "Помещения и стеллажи", description: "Справочники → Помещения, Стеллажи" },
      { title: "Ячейки", description: <Link to="/topology">Схема склада → «Сгенерировать ячейки», затем расставьте стеллажи на плане</Link> },
      { title: "Товары", description: <Link to="/storage_objects">Справочники → Объекты хранения (или импорт из Excel)</Link> },
      { title: "Пользователи", description: <Link to="/users">Администрирование → Пользователи и роли</Link> },
    ],
  },
];

export function HelpPage() {
  return (
    <div>
      <PageHeader title="Как работать с системой" />
      <Typography.Paragraph type="secondary">
        Три главных сценария по шагам. Подробная инструкция для новичков с описанием всех экранов и терминов есть у администратора системы.
      </Typography.Paragraph>
      <Row gutter={[16, 16]}>
        {FLOWS.map((flow) => (
          <Col key={flow.title} xs={24} lg={8}>
            <Card title={flow.title} size="small" style={{ height: "100%" }}>
              <Steps direction="vertical" size="small" current={-1} items={flow.steps} />
            </Card>
          </Col>
        ))}
      </Row>
      <Card size="small" style={{ marginTop: 16 }} title="Подсказки">
        <ul style={{ margin: 0, paddingLeft: 20 }}>
          <li>Поле «Штрихкод или код» в шапке открывает карточку товара или ячейки по сканированию.</li>
          <li>В списках работает поиск, сортировка по столбцам и импорт из XLSX/CSV (кнопка «Импорт», там же шаблон файла).</li>
          <li>Кнопки в карточке документа зависят от статуса: если действия нет, документ ещё не подтверждён или уже закрыт.</li>
          <li>Таблица «История» в карточке показывает, кто и что менял.</li>
          <li>Диспетчер видит все задачи и исполнителей в реальном времени в разделе «Склад → Диспетчер задач».</li>
          <li>План склада (Топология → Схема склада) показывает каждую ячейку цветом: наведите курсор, чтобы увидеть остаток, кликните, чтобы открыть содержимое. Схема в метрах: заполните длину и ширину помещения и габариты у типа ячейки, тогда стеллажи и залы будут в реальных пропорциях; клетка сетки = 1 м.</li>
        </ul>
      </Card>
    </div>
  );
}
